<template>
	<div class="sf-input-group-wrapper">
		<!--出库状态--> 
		<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC002149') }}{{ getMessage_('SWCC000141') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<!--전체-->
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option :key="index" v-for="(item, index) in outBoundStatusList" :label="item.commCdName" :value="item.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'outBoundStatus', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.data = this.searchParams.outBoundStatus;
		}
	},
	created() {
		if (this.searchParams.outBoundStatus == null || this.searchParams.outBoundStatus == '') this.searchParams.outBoundStatus = '';
		this.data = this.searchParams.outBoundStatus;
	}
};
</script>

<style></style>
